module.exports = __webpack_public_path__ + "img/return.bb8ec421.png";